<template>
  <div class="wrapper">
    <div id="javascriptComponents">
      <div class="title">
        <h2></h2>
      </div>
      <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
          <div class="md-layout">
            <div class="md-layout-item md-size-50">
            <a href="#/cores">
              <img
                src="@/assets/img/process.png"
                alt="Cores"
                class="img-raised img-fluid"
              />
              </a>
              <div class="title">
                <h4>Uso de horas Cores </h4>
              </div>
            </div>
            <div class="md-layout-item md-size-50">
            <a href="#/jobs">
              <img
                src="@/assets/img/mulitiple.png"
                alt="Cores"
                class="img-raised img-fluid"
              />
            </a>
              <div class="title">
                <h4>Ejecución de multiples Jobs </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="md-layout-item md-small-size-100">
          <div class="md-layout">
            <div class="md-layout-item md-size-50">
            <a href="#/asesor">
              <img
                src="@/assets/img/asesor.png"
                alt="Cores"
                class="img-raised img-fluid"
              />
            </a>
              <div class="title">
                <h4 >Asesorías en el uso de los clústers </h4>
              </div>
            </div>
            <div class="md-layout-item md-size-50">
              <a href="#/courses">
                <img
                  src="@/assets/img/curse.png"
                  alt="Cores"
                  class="img-raised img-fluid"
                />
              </a>
              <div class="title" >
                <h4 >Apoyo a cursos de HPC </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
            <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
          <div class="md-layout">
            <div class="md-layout-item md-size-25">
            <a href="#/congress">
                <img
                src="@/assets/img/congress.png"
                alt="Cores"
                class="img-raised img-fluid"
              />
            </a>
              <div class="title">
                <h4>Participación en congresos de HPC</h4>
              </div>
            </div>
            <div class="md-layout-item md-size-25">
              <a href="#/software">
                <img
                  src="@/assets/img/aprovisiona.png"
                  alt="Cores"
                  class="img-raised img-fluid"
                />
              </a>
              <div class="title">
                <h4>Aprovisionamiento de software libre </h4>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "@/components";
export default {
components: {
},
data() {
return {
classicModal: false,
selectedDate: new Date("2018/03/26")
};
},
methods: {
classicModalHide() {
this.classicModal = false;
}
}
};
</script>